export const DURUM_STYLES = {
    BEKLIYOR: "text-slate-400 border-slate-500/30 bg-slate-500/10",
    YAKLASIYOR: "text-amber-300 border-amber-500/40 bg-amber-500/10",
    HAZIR: "text-emerald-300 border-emerald-500/40 bg-emerald-500/10",
    GECIKTI: "text-red-300 border-red-500/40 bg-red-500/10",
};

export const DURUM_LABELS = {
    BEKLIYOR: "Bekliyor",
    YAKLASIYOR: "Yaklaşıyor",
    HAZIR: "Hazır",
    GECIKTI: "Gecikti",
};

export const SEGMENT_OPTIONS = [
    { key: "tumu", label: "Tümü", hint: "Bekleyen + aktif" },
    { key: "bekleyen", label: "Bekleme kuyruğu", hint: "Süre bekleyen" },
    { key: "aktif", label: "Aktif ön tahkim", hint: "ON_TAHKIM aşamasında" },
];
